module.exports = __webpack_public_path__ + "static/media/5.60375fe6.png";